import React from "react";
import AddDestinoForm from "./AddDestinoForm";

const AddDestino = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Destino"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddDestinoForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddDestino;
